export default __webpack_public_path__ + "images/value_tags/clean-0e063667030a9fa205458230ca08a082.svg";